'use client';

import cn from '@sindresorhus/class-names';
import type {ReactNode} from 'react';

import styles from './Button.module.scss';

type Props = {
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  children: ReactNode;
  disabled?: boolean;
};

export const Button = ({
  children,
  onClick,
  disabled,
  className,
  ...restProps
}: Props) => {
  return (
    <button
      className={cn(styles.button, className)}
      disabled={disabled}
      onClick={onClick}
      data-testid={'button_id'}
      {...restProps}
    >
      {children}
    </button>
  );
};
